
class CapCancelStudent {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'cancel_student'
}

function create(config) {
  return new CapCancelStudent(config)
}

export default {
  key,
  create,
}
